// Config & Control Centre (RCS-132) sidebar routing. Mirrors the API's
// ConfigurationRegistry::NAMESPACES — the key here IS the API namespace slug,
// used directly in the /config/{namespace} routes — except "access-scope",
// whose page is Administration › Data Scope (see namespaceRoute below). Two
// sidebar pages under the same section are NOT namespaces and route
// elsewhere: "KRI Configuration" is real CRUD on the existing KPI Thresholds
// lookup (see reference-data.kpi-thresholds), and "Configuration Governance"
// is the cross-namespace lifecycle dashboard (see ConfigGovernanceView.vue).
export interface ConfigNamespaceRoute {
  key: string;
  label: string;
  routeName: string;
  path: string;
}

const NAMESPACE_LABELS: Record<string, string> = {
  "regulatory-configuration": "Regulatory Configuration",
  "policy-configuration": "Policy Configuration",
  "compliance-configuration": "Compliance Configuration",
  "control-configuration": "Control Configuration",
  "breach-configuration": "Breach Configuration",
  "investigation-configuration": "Investigation Configuration",
  "rca-configuration": "RCA Configuration",
  "aml-configuration": "AML Configuration",
  "privacy-configuration": "Privacy Configuration",
  "market-conduct-configuration": "Market Conduct Configuration",
  "third-party-configuration": "Third-Party Risk Configuration",
  "technology-cyber-configuration": "Technology & Cyber Configuration",
  "model-risk-configuration": "Model Risk Configuration",
  "exceptions-waivers": "Exceptions & Waivers",
  "regulatory-return-configuration": "Regulatory Return Configuration",
  "licence-configuration": "Licence Configuration",
  "workflow-approval": "Workflow & Approval",
  "escalation-rules": "Escalation Rules",
  "access-sod-rules": "Access & SOD Rules",
  "notifications": "Notifications",
  "integration-configuration": "Integration Configuration",
  "metric-catalogue": "Metric Catalogue",
  "reference-numbering": "Reference Numbering",
  "business-calendar": "Business Calendar",
  "data-retention": "Data Retention",
};

export const CONFIG_NAMESPACES: ConfigNamespaceRoute[] = Object.entries(NAMESPACE_LABELS).map(([key, label]) => ({
  key,
  label,
  routeName: `config.${key}`,
  path: `/config/${key}`,
}));

// Namespaces administered outside /config, on the same ConfigPage.vue.
const ROUTE_OVERRIDES: Record<string, string> = {
  "access-scope": "admin.data-scope",
};

/**
 * The page for a namespace key the API returns, or null when the SPA has
 * none — linking to a route name that doesn't exist throws while rendering.
 */
export const namespaceRoute = (key: string): { name: string } | null => {
  const name = ROUTE_OVERRIDES[key] ?? CONFIG_NAMESPACES.find((ns) => ns.key === key)?.routeName;
  return name ? { name } : null;
};
